[
  {
    "id": "anchors",
    "short": "היסטוריה",
    "name": "אז ושם: היסטוריה עולמית",
    "blurb": "מאות אבני דרך מכל רחבי העולם ומכל התקופות, מהפירמידות ועד ימינו: מדע, דת, תרבות, גילויים ומהפכות."
  },
  {
    "id": "greco",
    "short": "יוון ורומא",
    "name": "יוון ורומא: העולם הקלאסי",
    "blurb": "ממלחמת טרויה ועד נפילת קונסטנטינופול: דמוקרטיה, קיסרות, פילוסופיה, הנדסה, ומורשת שעיצבה את המערב."
  },
  {
    "id": "jewish",
    "short": "ישראל ויהדות",
    "name": "היסטוריה ישראלית ויהודית",
    "blurb": "מאברהם אבינו ועד מדינת ישראל: בית ראשון ושני, גלות וגאולה, הגות, קהילות ומאבק לעצמאות."
  },
  {
    "id": "music",
    "short": "מוזיקה",
    "name": "תולדות המוזיקה",
    "blurb": "מהמזמורים העתיקים ועד הסטרימינג: קלאסית, ג׳אז, רוק, היפ-הופ, אלקטרוניקה — הצלילים שעיצבו את העולם."
  },
  {
    "id": "art",
    "short": "אמנות",
    "name": "תולדות האמנות",
    "blurb": "מציורי המערות ועד אמנות דיגיטלית: ציור, פיסול, אדריכלות, צילום ועיצוב — היצירות שהגדירו תקופות."
  }
]
